import { render, staticRenderFns } from "./viewClaim.vue?vue&type=template&id=5d06a21a&scoped=true&"
import script from "./viewClaim.vue?vue&type=script&lang=js&"
export * from "./viewClaim.vue?vue&type=script&lang=js&"
import style0 from "./viewClaim.vue?vue&type=style&index=0&id=5d06a21a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d06a21a",
  null
  
)

export default component.exports